<agr-page-sidesheet
  [wrapActions]="false"
  [pageTitle]="pageTitle$ | async"
  [hasSelection]="hasSelectedField$ | async"
  [isActive]="isEditing$ | async"
  (deselect)="deselect()"
  (deactivate)="cancel()"
  [hasPrimaryAction]="true"
  [primaryActionIcon]="primaryActionIcon$ | async"
  [primaryActionText]="primaryActionText$ | async | translate"
  [primaryActionWarn]="(isEditing$ | async) && (isModifying$ | async) === false"
  (primaryAction)="primaryAction()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
  [selectItems]="selectItems$ | async"
  (selectAction)="selectAction($event)"
  [hasSecondaryAction]="hasSecondaryAction$ | async"
  [secondaryActionIcon]="secondaryActionIcon$ | async"
  [secondaryActionText]="secondaryActionText$ | async | translate"
  (secondaryAction)="secondaryAction()"
  data-test="registration-root"
>
  <ng-container sidesheet>
    <mat-tab-group
      (selectedTabChange)="tabChange($event)"
      [mat-stretch-tabs]="false"
      #tabGroup="matTabGroup"
      color="accent"
      mat-align-tabs="start"
      class="cropfields-tab-group"
    >
      <mat-tab [label]="'Fields' | translate"> <app-cropfield-list></app-cropfield-list></mat-tab>
      <mat-tab [label]="'soilAnalyses' | translate">
        <app-soil-analysis-list></app-soil-analysis-list>
      </mat-tab>
    </mat-tab-group>
    @if (isInteractionTypeSelectCropField$ | async) {
      <div
        class="spacing--padding-all color--white"
        style="position: absolute; bottom: 0; width: 85%; z-index: 1"
      >
        <button
          mat-flat-button
          color="primary"
          class="spacing--padding-all"
          style="width: 100%"
          (click)="quickEditCropFields()"
          data-test="registration-button-quickedit"
        >
          <mat-icon>edit</mat-icon>{{ 'quickEditFields' | translate }}
        </button>
      </div>
    }
  </ng-container>
  <app-agr-geo
    [customLayerMenuItems]="layerMenuItems"
    content
    style="position: absolute; height: 100%; width: 100%"
  ></app-agr-geo>
</agr-page-sidesheet>
